import { ACTION_LINK_APP, ACTION_UNLINK_APP } from "."

export const linkAppRequest = (gate, appid, apkUrl) => ({
    type: ACTION_LINK_APP,
    payload: {
        gate, appid, apkUrl
    }
})

export const unLinkApp = () => ({
    type: ACTION_UNLINK_APP,
    payload: {}
})

export const linkApp = (gate, appid, apkUrl) => {
    return dispatch => {
        dispatch(linkAppRequest(gate, appid, apkUrl))
    }
}